import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import MojitoModules from 'mojito/modules';
import MojitoServices from 'mojito/services';
import { connect } from 'react-redux';

const PriceBoostCoupon = MojitoModules.PriceBoostCoupon;
const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const PageContextMenu = MojitoModules.PageContextMenu;
const {
    FlexPane,
    DocumentHead,
    GlobalLinks,
    PageHeader,
    PageSplitLayout,
    DefaultHeadMetaFactory,
    PageTitle,
} = MojitoPresentation.Components;
const SportsMenu = MojitoModules.SportsMenu.module;
const { PRICE_BOOST_EVENT_GROUP_NAME } = MojitoServices.EventGroups.types;
const { IntentActionTrigger } = MojitoPresentation.Base.Intent;
import { selectPreviousRoute } from 'applications/common/stores/router/selectors.js';

class PriceBoostPageView extends UIViewImplementation {
    constructor(props) {
        super(props);

        // Creating the MetaFactory instance here to avoid re-creating it on every render()
        const metaFactory = this.config.documentHeadMetaFactory || DefaultHeadMetaFactory;
        this.documentHeadMetaFactory = new metaFactory(this.l10n);
        this.onPageHeaderBackClicked = this.onPageHeaderBackClicked.bind(this);
    }

    onPageHeaderBackClicked() {
        this.props.previousRoute ? window.history.back() : IntentActionTrigger.showHomePage(false);
    }

    renderDocumentHead() {
        const headData = {
            title: '$PRICE_BOOST_PAGE.PAGE_TITLE',
            keywords: '$PRICE_BOOST_PAGE.PAGE_KEYWORDS',
            description: '$PRICE_BOOST_PAGE.PAGE_DESCRIPTION',
            canonical: '$PRICE_BOOST_PAGE.PAGE_CANONICAL',
        };

        return <DocumentHead data={headData} metaFactory={this.documentHeadMetaFactory} />;
    }

    renderPageHeader() {
        if (!this.config.showPageHeader) {
            return null;
        }

        return (
            <PageHeader
                label={this.resolveString('$PRICE_BOOST_PAGE.HEADER')}
                config={this.config.pageHeader}
                showBackButton={true}
                onBackClicked={this.onPageHeaderBackClicked}
            />
        );
    }
    renderPageTitle() {
        if (this.config.showPageTitle) {
            return (
                <PageTitle
                    config={this.config.pageTitle}
                    text={this.resolveString('$PRICE_BOOST_PAGE.PRICE_BOOST_LOGO_TITLE')}
                />
            );
        }
    }

    render() {
        return (
            <>
                {this.renderDocumentHead()}
                <PageSplitLayout>
                    <FlexPane config={this.config.primaryContent}>
                        {this.renderPageTitle()}
                        {this.renderPageHeader()}
                        <PriceBoostCoupon
                            boostedGroupId={PRICE_BOOST_EVENT_GROUP_NAME.ALL_SPORTS}
                            showSportTitles={true}
                        />
                    </FlexPane>
                    <FlexPane config={this.config.secondaryContentContainer}>
                        <PageContextMenu
                            config={this.config.pageContextMenu}
                            applicablePage="homepage"
                        />
                        <SportsMenu />
                        <GlobalLinks />
                    </FlexPane>
                </PageSplitLayout>
            </>
        );
    }
}

const mapStateToProps = state => ({
    previousRoute: selectPreviousRoute(state),
});
export default connect(mapStateToProps)(PriceBoostPageView);
